






































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import RichTextEditor from "./RichTextEditor.vue";
import { Getter } from "vuex-class";
import { SITE_LANG } from "../../store/getters.names";

@Component({
  name: "VideoForm",
  components: {
    RichTextEditor
  }
})
export default class VideoForm extends Vue {
  // {video:something, caption: something}
  @Prop() value: any;
  @Prop() anchor: number;
  @Prop() lang: string;

  translations: any = {
    caption: {
      en: "Caption",
      bn: "ক্যাপশান"
    },
    transcription: {
      en: "Transcription",
      bn: "ট্রান্সক্রিপশান"
    }
  };

  internalValue: any = JSON.parse(JSON.stringify(this.value));

  handleFileUpload(e) {
    var files = e.target.files || e.dataTransfer.files;
    // if (!files.length) return;
    this.internalValue.file = files;
  }

  @Watch("internalValue", { deep: true })
  handleChange(val: any, oldVal: any) {
    val.caption = val.caption_bn;
    val.transcript = val.transcript_bn;
    this.$emit("input", val);
  }
}
